<template>
  <router-view/>
</template>

<script>

</script>

<style lang="scss">
  *, *:before, *:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  }

  .container {
  width: 1312px;
  margin-left: auto;
  margin-right: auto;
  }

  body, html {
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  }

  .btn-red {
    cursor: pointer;
    text-align: center;
    height: 62px;
    padding: 0 25px;
    font-size: 1.7rem;
    line-height: 1.23529;
    background-color: #e30613;
    transition: all .15s;
    border-radius: 8px;
    border: 1px solid transparent;
    color: #ffffff;
    &:hover {
      background-color: #a7020d;
    }
  }

  #app {
    .container {
      width: auto;
    }
  }

  .modal-tv-detail {
    z-index: 1000 !important;
  }

  .channel-wrap {
    width: 12.5%;
  }

  @media (max-width: 1240px) {
    .channels-list {
      .channel-item-wrapper {
        width: 50% !important;
      }
    }

    .channel-wrap {
      width: 20%;
    }

  }

  @media (max-width: 992px) {

    .title-block {
      font-size: 24px;
    }

    .btn-red {
      padding: 0 25px;
      height: 40px;
      font-size: 1.4rem;
      line-height: 1.21429;
    }

    .channel-wrap {
      width: 25%;
    }

    .channels-list {
      .channel-item-wrapper {
        width: 50% !important;
      }
    }
    .desc-block {
      font-size: 14px;
    }

    .channels-list .channel-item-wrapper .channel-item .channel-title {
      font-size: 2.4rem;
    }

    .channels-list .channel-item-wrapper .channel-item .channel-price .card-price__summ {
      font-size: 3.4rem;
      margin-right: 8px;
      font-weight: 500;
    }

    .channels-list .channel-item-wrapper .channel-item .channel-price .card-price__format {
      font-size: 1.2rem;
    }

    .channels-list .channel-item-wrapper .channel-item .channel-btn button {
      padding: 0 25px;
      height: 40px;
      font-size: 1.4rem;
      line-height: 1.21429;
    }
  }

  @media (max-width: 820px) {

    .channels-title {
      font-size: 2.4rem;
      &:nth-child(3) {
        margin-top: 20px !important;

      }
    }
    .subtitle {
      font-size: 20px;
    }
    span[data-v-0a0426c1] {
      display: block;
      margin-top: 15px;
    }
    .channels-list {
      .channel-item-wrapper {
        width: 100% !important;
      }
    }
    .channels-list .channel-item-wrapper .channel-item .channel-btn button {
      font-size: 1.3rem;
    }
    .channels-list .channel-item-wrapper .channel-item .channel-btn {
      width: 53%;
    }
    .channels-list .channel-item-wrapper .channel-item {
      padding: 16px;
    }
    .channel-wrap {
      width: 50%;
    }
    .modal-tv-container {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .channels-list .channel-item-wrapper .channel-item {
    align-items: stretch !important;
  }

  .align-self-bottom {
    align-self: flex-end !important;
  }

  .button-row {
    button {
      padding: 0 32px !important;
    }
  }

  .loader {
    margin-top: 100px;
  }

  .channel-item {
    align-items: stretch !important;
  }

  #app {

  }
</style>
